var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"touchmove":function($event){$event.preventDefault();}}},[_c('v-header',{attrs:{"seller":_vm.seller}}),_c('div',{staticClass:"tab-wrapper"},[_c('tab',{ref:"tab",attrs:{"tabs":_vm.tabs}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }